import React from 'react';
import { Link } from "react-router-dom";
import '../styles/footer.css';
import {
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaGithub,
  FaEnvelope
} from 'react-icons/fa';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div className="footer-col brand">
          <h2 className="footer-logo">
            <span className="footer-icon">✨</span> Poly Quizz
          </h2>
          <p className="footer-desc">
            Your partner in exam success. We help students and professionals ace their exams through realistic simulations and targeted practice.
          </p>
          <div className="footer-socials">
            <FaFacebookF />
            <FaTwitter />
            <FaInstagram />
            <FaGithub />
          </div>
        </div>

        {/* Added "quick-links" class here to hide on mobile */}
        <div className="footer-col quick-links">
          <h3>Quick Links</h3>
          <ul>
            <li>
              <Link to="/" className="link-text">Home</Link>
            </li>
            <li>
              <Link to="/all-exam-prep-practice-test">Exams</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col">
          <h3>Exam Categories</h3>
          <ul>
            <li>
              <Link to="/all-exam-prep-practice-test#it-certifications">IT Certifications</Link>
            </li>
            <li>
              <Link to="/all-exam-prep-practice-test#medical-and-healthcare">Medical and Healthcare</Link>
            </li>
            <li>
              <Link to="/all-exam-prep-practice-test#academics-and-entrance">Academics and Entrance</Link>
            </li>
            <li>
              <Link to="/all-exam-prep-practice-test#languages-and-proficiency">Languages and Proficiency</Link>
            </li>
          </ul>
        </div>

        <div className="footer-col contact">
          <h3>Contact Us</h3>
          <ul className="contact-info">
            <li><FaEnvelope /> contact@polyquizz.com</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2025 PolyQuizz. All rights reserved.</p>
        <div className="footer-links">
          <Link to="/privacy-policy" className="link-text">
            Privacy Policy
          </Link>

          <Link to="/terms-of-service" className="link-text">
            Terms of Service
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;